var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CallbackRequestedSchema, VideoCallCompletedSchema, TestCompletedSchema, } from './schema';
var BASE_URL = process.env.REACT_APP_SALESFORCE_API_URL ||
    process.env.NEXT_PUBLIC_SALESFORCE_API_URL;
var API_KEY = process.env.REACT_APP_SALESFORCE_API_KEY ||
    process.env.NEXT_PUBLIC_SALESFORCE_API_KEY;
var SalesforceService = /** @class */ (function () {
    function SalesforceService() {
        this.headers = {
            'content-type': 'application/json',
        };
        validateEnv(process.env);
        this.setApiKey(API_KEY);
    }
    SalesforceService.prototype.sendTestCompleted = function (lead) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                TestCompletedSchema.parse(lead);
                return [2 /*return*/, this._apiCall({
                        url: "/salesforce/leads",
                        body: { lead: lead },
                        method: 'POST',
                    })];
            });
        });
    };
    SalesforceService.prototype.sendVideoCallCompleted = function (lead) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                VideoCallCompletedSchema.parse(lead);
                return [2 /*return*/, this._apiCall({
                        url: "/salesforce/leads",
                        body: { lead: lead },
                        method: 'POST',
                    })];
            });
        });
    };
    SalesforceService.prototype.sendCallbackRequested = function (lead) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                CallbackRequestedSchema.parse(lead);
                return [2 /*return*/, this._apiCall({
                        url: "/salesforce/leads",
                        body: { lead: lead },
                        method: 'POST',
                    })];
            });
        });
    };
    /**
     * Set the api key in the headers
     *
     * @param apiKey api key
     */
    SalesforceService.prototype.setApiKey = function (apiKey) {
        this.headers = __assign(__assign({}, this.headers), { 'x-api-key': apiKey || '' });
        return this;
    };
    SalesforceService.prototype._apiCall = function (_a) {
        var url = _a.url, body = _a.body, method = _a.method;
        return __awaiter(this, void 0, Promise, function () {
            var response, data, message, errors;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(BASE_URL).concat(url), {
                            method: method,
                            headers: this.headers,
                            body: JSON.stringify(body),
                        })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _b.sent();
                        if (response.ok) {
                            return [2 /*return*/, data];
                        }
                        else {
                            message = (data === null || data === void 0 ? void 0 : data.message) || 'Error sending data to salesforce';
                            errors = (data === null || data === void 0 ? void 0 : data.errors)
                                ? Object.values(data.errors)
                                    .map(function (error) { return "\t".concat(error); })
                                    .join('\n')
                                : '';
                            throw new Error("SalesforceService \n".concat(message, ":\n").concat(errors));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SalesforceService;
}());
export { SalesforceService };
function validateEnv(env) {
    var flag = false;
    if (!BASE_URL) {
        console.warn('SalesforceService: REACT_APP_SALESFORCE_API_URL key is not set');
        flag = true;
    }
    if (!API_KEY) {
        console.warn('SalesforceService: REACT_APP_SALESFORCE_API_KEY key is not set');
        flag = true;
    }
    if (flag)
        throw new Error('SalesforceService: Missing environment variables');
}
